import React from "react";
import moment from "moment";
import TimeAgo from "react-time-ago";
import DashIcon from "react-icons/lib/md/linear-scale";
import FileDownloadIcon from "react-icons/lib/md/file-download";
import { appConstants, commonConstants } from "../../_constants";
import { commonService } from "../../_services";
import { appHelpers } from "../../_helpers";
import ToolTipItem from "../utils/tooltip";
import { apiActions, alertActions } from "../../_actions";

class IataCompletedRecord extends React.Component {
  
  trackFileDownload = (Url, fetchCallback) => {
    console.log(Url, "Url in trackFileDownload");
    commonService.downloadSpecificIataReport(Url).then((res) => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        //    File marked successfully
        const response = res.response.data;
        const isBase64 = !!response.base64File;
        const fileData = response.base64File || response;
        // 🔑 Infer mimeType from file extension in Url
        let mimeType = "application/octet-stream"; // fallback
        if (Url.toLowerCase().endsWith(".pdf")) {
          mimeType = "application/pdf";
        } else if (Url.toLowerCase().endsWith(".xlsx")) {
          mimeType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        } else if (Url.toLowerCase().endsWith(".xls")) {
          mimeType = "application/vnd.ms-excel";
        } else if (Url.toLowerCase().endsWith(".csv")) {
          mimeType = "text/csv";
        }

        const fileName = Url.split("/").pop().split(".")[0];

        appHelpers.downloadFileV2(fileData, fileName, isBase64, mimeType);
        fetchCallback();
      }
    });
  };

  render() {
    const { report, fetchCallBack } = this.props;
    return (
      <div
        className={
          "timeline-box-w completed " + (report.DowloadCount > 0 ? "" : "new")
        }
      >
        <div className="timeline-time">
          <span>
            <TimeAgo>
              {parseInt(moment(report.EntryDateTime).format("x"), 0)}
            </TimeAgo>
          </span>
        </div>
        <div className="timeline-box">
          <div className="timeline-info">
            <h6 className="timeline-role">{report.AirlineName}</h6>

            <h6>
              {moment(report.SearchStartDate.split("T")[0]).format(
                "MMM Do, YYYY"
              )}
              &nbsp;&nbsp;
              <DashIcon size="22" color="#212121" />
              &nbsp;&nbsp;
              {moment(report.SearchEndDate.split("T")[0]).format(
                "MMM Do, YYYY"
              )}
            </h6>
            <div>
              <span
                onClick={() =>
                  this.trackFileDownload(report.Url, fetchCallBack)
                }
              >
                {/* <a  className={'success-link'} download href={report.Url} style={{color: '#00887b !important'}}> */}
                <FileDownloadIcon size="18" color="#00887b" />
                &nbsp;Download
                {report.DowloadCount > 0 && (
                  <ToolTipItem
                    key={report.JobId + "iataDownload"}
                    title={<span> &nbsp;|&nbsp; {report.DowloadCount} </span>}
                    content="Number of downloads"
                    id={report.JobId + "iataDownload"}
                  />
                )}
                {/* </a> */}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default IataCompletedRecord;



// WEBPACK FOOTER //
// ./src/views/iata/iata-completed-record.js